export default "__VITE_ASSET__D$G$xUoy__"